import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify, { colors } from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'

//import '../assets/my_themes.styl'

Vue.use(Vuetify)

import it from 'vuetify/src/locale/it.ts'

const opts = {
    icons: {
        iconfont: 'md',
    },
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                disabled: colors.blueGrey.darken1,
                warning: colors.orange,
                suggestion: colors.cyan.darken2,
                primary: colors.cyan.darken2,
                expansion: colors.cyan.lighten5
            },
            dark: {
                disabled: colors.blueGrey.lighten3,
                warning: colors.orange,
                suggestion: colors.cyan.darken2,
                primary: colors.cyan.darken2,
                expansion: colors.cyan.darken6
            }
        }
    },
    lang: {
        locales: { it },
        current: 'it',
    },
}

export default new Vuetify(opts)